import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAppSelector } from '../../store/hooks';
import { hasFeatureAccess, USER_ROLES } from '../../config/roleFeatures';

const ProtectedRoute = ({ children, requiredFeature }) => {
  const { user, isAuthenticated } = useAppSelector((state) => state.auth);
  
  // If not authenticated, redirect to login
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }
  
  // If no feature requirement, allow access (for basic authenticated routes)
  if (!requiredFeature) {
    return children;
  }
  
  // Check if user has access to the required feature
  const userRole = user?.admin_role?.toUpperCase();
  const hasAccess = hasFeatureAccess(userRole, requiredFeature);
  
  // If no access, redirect based on user role
  if (!hasAccess) {
    // For employees, redirect to POS (their first available page)
    if (userRole === USER_ROLES.EMPLOYEE) {
      return <Navigate to="/pos" replace />;
    }
    // For others, redirect to dashboard
    return <Navigate to="/dashboard" replace />;
  }
  
  return children;
};

export default ProtectedRoute;